<template>
  <v-container v-if="loadedSettings" fluid>
    <v-card outlined>
      <v-card-text>
        <v-row v-if="loadedSettings.onCreateSubOrderEmail" >
         <v-col>
           <v-switch
             v-model="loadedSettings.onCreateSubOrderEmail.activate"
             :disabled="loading"
             :label="$t('settings.onCreateSuborderEmail.activate.label')"
             :messages="$t('settings.onCreateSuborderEmail.activate.message')"
           />
           <v-card outlined class="mt-4" v-if="loadedSettings.onCreateSubOrderEmail.activate">
             <v-card-text class="ps-6 py-2">
               <v-switch
                 v-model="loadedSettings.onCreateSubOrderEmail.location.activate"
                 :disabled="loading || !loadedSettings.onCreateSubOrderEmail.activate"
                 :label="$t(`settings.onCreateSuborderEmail.location.label`)"
               />
               <v-switch
                 v-model="loadedSettings.onCreateSubOrderEmail.location_managers.activate"
                 :disabled="loading || !loadedSettings.onCreateSubOrderEmail.activate"
                 :label="$t(`settings.onCreateSuborderEmail.location_managers.label`)"
               />
               <v-switch
                 v-model="loadedSettings.onCreateSubOrderEmail.location_managers.restrict_to_main"
                 :disabled="loading || !loadedSettings.onCreateSubOrderEmail.activate"
                 :label="$t('settings.onCreateSuborderEmail.location_managers.restrict_to_main.label')"
                 class="ps-4 ps-sm-8 ps-md-10"
               />
             </v-card-text>
           </v-card>
         </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-switch
              v-model="loadedSettings.onCreateSubOrderPushNotificationActivate"
              :disabled="loading"
              :label="$t('settings.onCreateSuborderPushNotificationActivate')"
              :messages="$t('settings.onCreateSuborderPushNotificationActivateMessage')"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <notification-settings-alerts-table
      :alerts="loadedSettings.alerts"
      :loading="loading"
      :alreadySelectedStatus="alreadySelectedStatus"
      @open-new="openNewAlertFormDialog"
      @edit="openModifyAlertFormDialog"
      @delete="openDeleteAllocationDialog"
    />
    <confirmation-dialog
      v-model="deleteAlertDialog"
      :text="$t('settings.alerts.deleteAlertText')"
      :title="$t('settings.alerts.deleteAlertTitle')"
      @no="deleteAlertDialog = false"
      @yes="deleteItem"
    />
    <alert-form-dialog
      v-if="newAlertFormDialog"
      v-model="newAlertFormDialog"
      :unavailableTriggeringStatus = "alreadySelectedStatus"
      @validateForm="addAlert"
      @close="newAlertFormDialog = false"
    />
    <alert-form-dialog
      v-if="modifyAlertFormDialog"
      v-model="modifyAlertFormDialog"
      :unavailableTriggeringStatus = "alreadySelectedStatus"
      :formValue="selectedAlert"
      @validateForm="updateAlert"
      @close="modifyAlertFormDialog = false"
    />
  </v-container>
</template>

<script>
import confirmationDialog from '@/components/ConfirmationDialog'
import AlertFormDialog from "@/components/dialogs/AlertFormDialog.vue"
import notificationSettingsAlertsTable from "./NotificationSettingsAlertsTable.vue"

export default {
  name: 'NotificationSettings',
  components: {
    "confirmationDialog": confirmationDialog,
    "AlertFormDialog": AlertFormDialog,
    "notificationSettingsAlertsTable": notificationSettingsAlertsTable
  },
  props: {
    loadedSettings: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedAlert: undefined,
      deleteAlertDialog: false,
      newAlertFormDialog: false,
      modifyAlertFormDialog: false
    }
  },
  computed: {
    headers () {
      return [
        {
          text:  this.$t('settings.alerts.name'),
          value: 'name'
        },
        {
          text:  this.$t('settings.active'),
          value: 'activate'
        },
        {
          text: '',
            value: 'actions',
            sortable: false,
        }
      ]
    },
    alreadySelectedStatus() {
      return this.loadedSettings?.alerts?.flatMap(alert => alert.onStatus) || []
    }
  },
  watch: {
    'loadedSettings.onCreateSubOrderEmail.location_managers.activate':{
      handler: function (newValue){
        if(newValue === false){
          this.loadedSettings.onCreateSubOrderEmail.location_managers.restrict_to_main = false
        }
      }
    },
    'loadedSettings.onCreateSubOrderEmail.location_managers.restrict_to_main':{
      handler: function (newValue){
        if(newValue === true){
          this.loadedSettings.onCreateSubOrderEmail.location_managers.activate = true
        }
      }
    }
  },
  methods: {
    openNewAlertFormDialog() {
      this.newAlertFormDialog = true
    },
    addAlert(newAlert) {
      this.loadedSettings.alerts.unshift(newAlert)
      this.newAlertFormDialog = false
    },
    openModifyAlertFormDialog(item) {
      this.selectedAlert = item
      this.modifyAlertFormDialog = true
    },
    updateAlert(updatedAlert){
      this.$set(this.loadedSettings.alerts, this.loadedSettings.alerts.indexOf(this.selectedAlert), updatedAlert)
      this.selectedAlert = {}
      this.modifyAlertFormDialog = false
    },
    openDeleteAllocationDialog(item) {
      this.selectedAlert = item
      this.deleteAlertDialog = true
    },
    deleteItem(){
      this.loadedSettings.alerts.splice(this.loadedSettings.alerts.indexOf(this.selectedAlert), 1)
      this.deleteAlertDialog = false
      this.selectedAlert = {}
    },
  }
}
</script>
